import React from 'react';
import css from './index.css';
import Animation from './devlanguages';
import All from './iconsbuttons';
import Codes from './codeshower.js';

export default function Main() {

  
  
  return (
    <main id="main">
    <All/>
    <Animation/>
    <Codes/>
    </main>
  );
}
